import { render, staticRenderFns } from "./HoldDefectForm.vue?vue&type=template&id=1c141771&scoped=true&"
import script from "./HoldDefectForm.vue?vue&type=script&lang=ts&"
export * from "./HoldDefectForm.vue?vue&type=script&lang=ts&"
import style0 from "./HoldDefectForm.vue?vue&type=style&index=0&id=1c141771&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c141771",
  null
  
)

export default component.exports